"use strict";

jQuery(document).on("custom_DKT_libraries_loaded", function() {
    DKTFavorites.init();
    DKTMap.init();
    DKTPaths.initInfantilPage();
  
    var infantilData = DKTPaths.getInfantilData();
    DKTMap.drawPaths(infantilData);
    DKTMap.drawStartingPoints(infantilData);
    DKTMap.zoomToSelectedTamborrada();
});
